import Assign from "./Assign/Assign";
import Length from "./Length/Length";
import Lowercase from "./Lowercase/Lowercase";
import Uppercase from "./Uppercase/Uppercase";
import Substring from "./Substring/Substring";
import Split from "./Split/Split";
import Replace from "./Replace/Replace";
import { types } from "./types";
import Search from "./Search/Search";
import Trim from "./Trim/Trim";
import ConvertNumber from "./ConvertNumber/ConvertNumber";
import ConvertDate from "./ConvertDate/ConvertDate";
import Capitalize from "./Capitalize/Capitalize";
import Prepend from "./Prepend/Prepend";
import Append from "./Append/Append";
import Regex from "./Regex/Regex";

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      Kerem Karadeniz
 */
function Actions(
  action,
  showAlert,
  variables,
  setOpenVariable,
  variableRender,
  setField,
  disabled,
  outputVisible,
  visible
) {
  // control of action name tjen return component
  switch (action.actionName) {
    case types.ASSIGN:
      return (
        <Assign
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          setField={setField}
          disabled={disabled}
          outputVisible={outputVisible}
          visible={visible}
        />
      );
    case types.LENGTH:
      return (
        <Length
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    case types.LOWERCASE:
      return (
        <Lowercase
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          setField={setField}
          disabled={disabled}
          outputVisible={outputVisible}
          visible={visible}
        />
      );
    case types.UPPERCASE:
      return (
        <Uppercase
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          setField={setField}
          disabled={disabled}
          outputVisible={outputVisible}
          visible={visible}
        />
      );
    case types.SUBSTRING:
      return (
        <Substring
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          setField={setField}
          disabled={disabled}
          outputVisible={outputVisible}
          visible={visible}
        />
      );
    case types.SPLIT:
      return (
        <Split
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    case types.REPLACE:
      return (
        <Replace
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          setField={setField}
          disabled={disabled}
          outputVisible={outputVisible}
          visible={visible}
        />
      );
    case types.SEARCH:
      return (
        <Search
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );

    case types.TRIM:
      return (
        <Trim
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          setField={setField}
          disabled={disabled}
          outputVisible={outputVisible}
          visible={visible}
        />
      );
    case types.CONVERTNUMBER:
      return (
        <ConvertNumber
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    case types.CONVERTDATE:
      return (
        <ConvertDate
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    case types.CAPITALIZE:
      return (
        <Capitalize
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          visible={visible}
        />
      );
    case types.PREPEND:
      return (
        <Prepend
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          setField={setField}
          disabled={disabled}
          outputVisible={outputVisible}
          visible={visible}
        />
      );
    case types.APPEND:
      return (
        <Append
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          setField={setField}
          disabled={disabled}
          outputVisible={outputVisible}
          visible={visible}
        />
      );
    case types.REGEX:
      return (
        <Regex
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          setField={setField}
          disabled={disabled}
          outputVisible={outputVisible}
          visible={visible}
          variableRender={variableRender}
        />
      );
    default: break;
  }
}

export default Actions;
